import ctaImg from '../../images/preview/bg.jpg'
import shapeImg1 from '../../images/preview/shape/shape-1.png'
import shapeImg2 from '../../images/preview/shape/shape-2.png'

const CtaSection = (props) => {

    return (
        <section className="preview-banner" style={{ backgroundImage: `url(${ctaImg})` }}>
            <div className="container-fluid">
                <div className="wpo-offer-wrap">
                    <div className="wpo-offer-items">
                        <div className="wpo-offer-item">
                            <div className="wpo-offer-right">
                                <h2>Stunning & Unique Wedding Website For
                                    Creating Your Dreamy Website.  </h2>
                                <p>We create for you a complete package of wedding website. Here we have more than 14+ wedding, invitation, planner, gallery, RSVP & shop home pages. we tried our best to complete your needs to build your wished website.</p>
                                <a target="_blank" rel="noopener noreferrer"  href="https://1.envato.market/vPL4xO" className="theme-btn">Purchase Now</a>
                            </div>
                            <div className="shape-1 wow fadeInLeftSlow" data-wow-duration="1400ms"><img src={shapeImg1} alt=""/>
                            </div>
                            <div className="shape-2 wow fadeInRightSlow" data-wow-duration="1400ms"><img src={shapeImg2} alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default CtaSection;